import { Route } from '@angular/router';
import { authGuard, onboardingGuard } from '@olonera/auth';
import { AuthenticatedLayoutComponent } from './features/authenticated-layout/authenticated-layout';
import { PageNotFoundComponent, AccessDeniedComponent } from '@olonera/ui';
import { PlanListComponent, PlanDetailComponent } from '@olonera/treatment-plans';

export const appRoutes: Route[] = [
    {
        path: 'auth',
        loadChildren: () => import('@olonera/auth').then(m => m.AUTH_ROUTES)
    },
    {
        path: 'profile-setup',
        canActivate: [authGuard, onboardingGuard],
        loadComponent: () => import('./features/profile-setup/profile-setup').then(m => m.PatientProfileSetupComponent)
    },
    {
        path: '',
        canActivate: [authGuard],
        component: AuthenticatedLayoutComponent,
        children: [
            {
                path: 'dashboard',
                canActivate: [onboardingGuard],
                loadComponent: () => import('./features/dashboard/dashboard').then(m => m.DashboardComponent)
            },
            {
                path: 'appointments/:id/review-redirect',
                canActivate: [onboardingGuard],
                loadComponent: () => import('./features/appointments/review-redirect').then(m => m.ReviewRedirectComponent)
            },
            {
                path: 'marketplace',
                canActivate: [onboardingGuard],
                loadComponent: () => import('./features/marketplace/marketplace-sso').then(m => m.MarketplaceSsoComponent)
            },
            {
                path: 'orders',
                canActivate: [onboardingGuard],
                loadComponent: () => import('./features/marketplace/orders-sso').then(m => m.OrdersSsoComponent)
            },
            {
                path: 'education',
                canActivate: [onboardingGuard],
                loadComponent: () => import('./features/marketplace/library-sso').then(m => m.LibrarySsoComponent)
            },
            {
                path: 'access-denied',
                component: AccessDeniedComponent
            },
            {
                path: 'appointments',
                canActivate: [onboardingGuard],
                loadComponent: () => import('./features/calendar/pages/calendar-view/patient-calendar').then(m => m.PatientCalendarPageComponent)
            },
            {
                path: 'appointments/:id',
                canActivate: [onboardingGuard],
                loadComponent: () => import('./features/calendar/pages/calendar-view/patient-calendar').then(m => m.PatientCalendarPageComponent)
            },
            {
                path: 'book-appointment',
                canActivate: [onboardingGuard],
                loadComponent: () => import('./features/calendar/pages/book-appointment/book-appointment').then(m => m.BookAppointmentComponent)
            },
            {
                path: 'messages',
                canActivate: [onboardingGuard],
                loadComponent: () => import('./features/messages/messages.page').then(m => m.MessagesPage)
            },
            {
                path: 'health-profile',
                canActivate: [onboardingGuard],
                loadComponent: () => import('./features/health-profile/health-profile').then(m => m.HealthProfilePageComponent)
            },
            {
                path: 'settings',
                canActivate: [onboardingGuard],
                loadComponent: () => import('./features/settings/settings').then(m => m.SettingsComponent)
            },
            {
                path: 'support',
                canActivate: [onboardingGuard],
                loadComponent: () => import('./features/support/support').then(m => m.SupportPageComponent)
            },
            {
                path: 'specialists',
                canActivate: [onboardingGuard],
                loadChildren: () => import('./features/practitioners/practitioners.routes').then(m => m.PRACTITIONER_ROUTES)
            },
            {
                path: 'plans',
                canActivate: [onboardingGuard],
                children: [
                    {
                        path: '',
                        component: PlanListComponent
                    },
                    {
                        path: ':id',
                        component: PlanDetailComponent
                    }
                ]
            },
            {
                path: 'resources',
                canActivate: [onboardingGuard],
                loadChildren: () => import('@olonera/practitioner-resources').then(m => m.RESOURCES_ROUTES)
            },
            { path: '', redirectTo: 'dashboard', pathMatch: 'full' }
        ]
    },
    { path: '**', component: PageNotFoundComponent }
];
